export default __webpack_public_path__ + "static/media/last-block.ad3b10f2.svg";